import useCalculateCronosEthereumBridgeFee from './useCalculateCronosEthereumBridgeFee';

export default useCalculateCronosEthereumBridgeFee;
